import axios from "axios";

export default class HttpClient {
  constructor(token) {
    this.headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Accept: "application/json"
    };
    this.token = token;

    //window.apiBaseUrl must be set in application
    if (window.apiBaseUrl === null) {
      console.error("You have to set window.apiBaseUrl!");
    }
  }

  post(body, apiUrl, conf) {
    const axiosConfig = conf || this.headers;
    const url = window.apiBaseUrl + apiUrl;
    if (this.token) {
      axiosConfig.jwt = this.token;
    }

    return axios({
      method: "POST",
      url: url,
      headers: axiosConfig,
      data: body
    })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  }
  get(apiUrl, conf) {
    const axiosConfig = conf || this.headers;
    const url = window.apiBaseUrl + apiUrl; //'/biframework/package/getdefault'

    if (this.token) {
      axiosConfig.jwt = this.token;
    }

    return axios({
      method: "GET",
      url: url,
      headers: axiosConfig
    })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err.response;
      });
  }
}



// WEBPACK FOOTER //
// ./retts/HttpClient/HttpClient.js